import React, { ReactNode } from "react";
import { Breakpoint } from "@mui/material";
import { Typography } from "@platform/design-system";

import { Button, ButtonProps } from "../Button";
import { Dialog } from "../Dialog";

export type ConfirmationModalProps = {
  onCancel: () => void;
  onAccept: () => void;
  open: boolean;
  title: string;
  description: string;
  confirmButtonText: string;
  cancelButtonText: string;
  loading?: boolean;
  additionalMessage?: ReactNode;
  actions?: ReactNode;
  maxWidth?: Breakpoint;
  ConfirmButtonProps?: ButtonProps;
  CancelButtonProps?: ButtonProps;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  onCancel,
  onAccept,
  open,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
  loading = false,
  additionalMessage,
  actions,
  maxWidth = "sm",
  ConfirmButtonProps,
  CancelButtonProps,
}) => (
  <Dialog
    data-testid="ds-confirmation-modal"
    open={open}
    onClose={onCancel}
    title={title}
    maxWidth={maxWidth}
    actions={
      actions ?? (
        <>
          <Button
            data-testid="ds-confirmation-modal-cancel-button"
            variant="secondary"
            {...CancelButtonProps}
            onClick={onCancel}
            disabled={loading}
          >
            {cancelButtonText}
          </Button>
          <Button
            data-testid="ds-confirmation-modal-confirm-button"
            variant="primary"
            {...ConfirmButtonProps}
            onClick={onAccept}
            disabled={loading}
            loading={loading}
          >
            {confirmButtonText}
          </Button>
        </>
      )
    }
  >
    {additionalMessage && (
      <Typography mb={3} textTransform="uppercase" variant="body-large">
        <strong>{additionalMessage}</strong>
      </Typography>
    )}

    <Typography mb={3} variant="body-large">
      {description}
    </Typography>
  </Dialog>
);

export { ConfirmationModal };
